<template>
  <v-container>
    <div :class="[`text-subtitle-1`]">
      <h4>Language(s)</h4>
    </div>
    <div class="card grey-card" v-for="(item, i) in lang_list" :key="i">
      <v-row>
        <v-col md="11" sm="10" cols="10">
          <v-row>
            <v-col cols="6">
              <v-select :items="language_list" item-text="label" item-value="value" label="Language"
                v-model="lang_list[i].language" outlined dense></v-select>
            </v-col>
            <v-col cols="6">
              <v-select :items="level" item-text="label" item-value="value" label="Speak level"
                v-model="lang_list[i].speak_level" outlined dense></v-select>
            </v-col>
            <v-col cols="6">
              <v-select :items="level" item-text="label" item-value="value" label="Read level"
                v-model="lang_list[i].read_level" outlined dense></v-select>
            </v-col>
            <v-col cols="6">
              <v-select :items="level" item-text="label" item-value="value" label="Write level"
                v-model="lang_list[i].write_level" outlined dense></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="1" sm="2" cols="2">
          <v-btn @click="removeLang(i)" small text color="red">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-btn @click="addLang()" small>
      Add language
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: 'AppLanguage',
  props: ['lang_list', 'remove_langs'],
  data: () => ({
    language: [],
    level: [
      { label: '-', value: null },
      { label: 'Little', value: 'little' },
      { label: 'Fair', value: 'fair' }
    ],
    language_list: [
      { label: 'Thai', value: 'Thai' },
      { label: 'English', value: 'English' },
      { label: 'Japanese', value: 'Japanese' },
      { label: 'Korean', value: 'Korean' },
      { label: 'Chinese', value: 'Chinese' },
      { label: 'Hindi', value: 'Hindi' },
      { label: 'Lao', value: 'Lao' },
      { label: 'Russian', value: 'Russian' },
      { label: 'Arabic', value: 'Arabic' },
      { label: 'Other', value: 'Other' },
    ]
  }),
  methods: {
    addLang() {
      this.lang_list.push({ language: '', level: null })
    },
    removeLang(index) {
      if (this.lang_list[index].id)
        this.remove_langs.push(this.lang_list[index].id)
      this.lang_list.splice(index, 1)
    }
  },
}
</script>